import React, { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import Label from '@components/inputs/text/Label';
import { textBoxStyle } from '@utils/styles/textboxStyle';
import { NavBar } from "@components/navigation/NavBar/NavBar";
import SubmitBtn from "@components/buttons/FormButtons/SubmitBtn";
import { OnboardingEmergencyContactsState, OnboardingEmergencyContactsAction } from './onboardingEmergencyContactsReducer';

interface FlexiOwnEmergencyContactsV2Props {
  navigateTarget: string;
  onboardingEmergencyContactsState: OnboardingEmergencyContactsState;
  onboardingEmergencyContactsDispatch: React.Dispatch<OnboardingEmergencyContactsAction>;
}

export default function FlexiOwnEmergencyContactsV2({
  navigateTarget,
  onboardingEmergencyContactsState,
  onboardingEmergencyContactsDispatch
}: FlexiOwnEmergencyContactsV2Props) {
  const navigate = useNavigate();

  const onEmergencyContactInfoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.currentTarget.name) {
      case 'primaryName':
        onboardingEmergencyContactsDispatch({ type: "SET_PRIMARY_NAME", payload: e.currentTarget.value });
        break;
      case 'primaryAddress':
        onboardingEmergencyContactsDispatch({ type: "SET_PRIMARY_ADDRESS", payload: e.currentTarget.value });
        break;
      case 'primaryPhone':
        onboardingEmergencyContactsDispatch({ type: "SET_PRIMARY_PHONE", payload: e.currentTarget.value });
        break;
      case 'primaryRelationship':
        onboardingEmergencyContactsDispatch({ type: "SET_PRIMARY_RELATIONSHIP", payload: e.currentTarget.value });
        break;
      case 'secondaryName':
        onboardingEmergencyContactsDispatch({ type: "SET_SECONDARY_NAME", payload: e.currentTarget.value });
        break;
      case 'secondaryAddress':
        onboardingEmergencyContactsDispatch({ type: "SET_SECONDARY_ADDRESS", payload: e.currentTarget.value });
        break;
      case 'secondaryPhone':
        onboardingEmergencyContactsDispatch({ type: "SET_SECONDARY_PHONE", payload: e.currentTarget.value });
        break;
      case 'secondaryRelationship':
        onboardingEmergencyContactsDispatch({ type: "SET_SECONDARY_RELATIONSHIP", payload: e.currentTarget.value });
        break;
    }
  };

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    navigate(navigateTarget);
  };

  return (
    <>
      <NavBar pageTitle={"Emergency Contacts"} backAction={undefined} />
      <form style={{ margin: '2.5vh 2.5vw' }} onSubmit={onSubmit}>
        <div style={{ margin: '2.5vh 0vw' }}>
          <p>Please provide details of two emergency contacts.</p>
        </div>

        <div style={{ margin: '2.5vh 0vw' }}>
          <Label text={'Name'} requiredFieldInd={true} />
          <input
            style={textBoxStyle}
            name='primaryName'
            defaultValue={onboardingEmergencyContactsState.primaryName}
            required={true}
            onChange={onEmergencyContactInfoChange}
          />
        </div>

        <div style={{ margin: '2.5vh 0vw' }}>
          <Label text={'Address'} requiredFieldInd={true} />
          <input
            style={textBoxStyle}
            name='primaryAddress'
            defaultValue={onboardingEmergencyContactsState.primaryAddress}
            required={true}
            onChange={onEmergencyContactInfoChange}
          />
        </div>

        <div style={{ margin: '2.5vh 0vw' }}>
          <Label text={'Phone'} requiredFieldInd={true} />
          <input
            style={textBoxStyle}
            name='primaryPhone'
            defaultValue={onboardingEmergencyContactsState.primaryPhone}
            required={true}
            onChange={onEmergencyContactInfoChange}
          />
        </div>

        <div style={{ margin: '2.5vh 0vw' }}>
          <Label text={'Relationship to you'} requiredFieldInd={true} />
          <input
            style={textBoxStyle}
            name='primaryRelationship'
            defaultValue={onboardingEmergencyContactsState.primaryRelationship}
            required={true}
            onChange={onEmergencyContactInfoChange}
          />
        </div>

        <div style={{ margin: '2.5vh 0vw' }}>
          <p>
            <strong>Alternative Emergency Contact</strong> (who does not reside with you)
          </p>
        </div>

        <div style={{ margin: '2.5vh 0vw' }}>
          <Label text={'Name'} />
          <input
            style={textBoxStyle}
            name='secondaryName'
            defaultValue={onboardingEmergencyContactsState.secondaryName}
            onChange={onEmergencyContactInfoChange}
          />
        </div>

        <div style={{ margin: '2.5vh 0vw' }}>
          <Label text={'Address'} />
          <input
            style={textBoxStyle}
            name='secondaryAddress'
            defaultValue={onboardingEmergencyContactsState.secondaryAddress}
            onChange={onEmergencyContactInfoChange}
          />
        </div>

        <div style={{ margin: '2.5vh 0vw' }}>
          <Label text={'Phone'} />
          <input
            style={textBoxStyle}
            name='secondaryPhone'
            defaultValue={onboardingEmergencyContactsState.secondaryPhone}
            onChange={onEmergencyContactInfoChange}
          />
        </div>

        <div style={{ margin: '2.5vh 0vw' }}>
          <Label text={'Relationship to you'} />
          <input
            style={textBoxStyle}
            name='secondaryRelationship'
            defaultValue={onboardingEmergencyContactsState.secondaryRelationship}
            onChange={onEmergencyContactInfoChange}
          />
        </div>

        <SubmitBtn text={"Next"} />
      </form>
    </>
  );
}